import React from "react";

function BoostPlanIcon() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 23.9945C0 10.7427 10.7427 0 23.9945 0C37.2464 0 47.9891 10.7427 47.9891 23.9945C47.9891 37.2464 37.2464 47.9891 23.9945 47.9891C10.7427 47.9891 0 37.2464 0 23.9945Z"
        fill="#F3E8FF"
      />
      <path
        d="M15.9871 25.9941C15.7979 25.9947 15.6124 25.9417 15.4521 25.8411C15.2919 25.7405 15.1635 25.5965 15.0818 25.4259C15.0002 25.2552 14.9686 25.0649 14.9908 24.877C15.013 24.6891 15.0881 24.5114 15.2072 24.3644L25.105 14.1668C25.1792 14.0811 25.2804 14.0232 25.3919 14.0025C25.5034 13.9819 25.6186 13.9998 25.7186 14.0533C25.8186 14.1068 25.8974 14.1927 25.9421 14.2968C25.9869 14.401 25.9949 14.5173 25.9648 14.6267L24.0452 20.6453C23.9886 20.7968 23.9696 20.9597 23.9898 21.1202C24.0101 21.2806 24.0689 21.4338 24.1613 21.5665C24.2537 21.6992 24.3769 21.8075 24.5204 21.8822C24.6639 21.9568 24.8233 21.9955 24.985 21.995H31.9834C32.1726 21.9943 32.3581 22.0474 32.5184 22.148C32.6786 22.2486 32.807 22.3925 32.8887 22.5632C32.9703 22.7339 33.0019 22.9242 32.9797 23.1121C32.9575 23.3 32.8824 23.4777 32.7633 23.6246L22.8655 33.8223C22.7913 33.908 22.6901 33.9659 22.5786 33.9865C22.4671 34.0071 22.3519 33.9892 22.2519 33.9358C22.1519 33.8823 22.0731 33.7964 22.0284 33.6922C21.9836 33.588 21.9756 33.4717 22.0057 33.3624L23.9253 27.3438C23.9819 27.1923 24.0009 27.0293 23.9807 26.8689C23.9604 26.7084 23.9016 26.5553 23.8092 26.4226C23.7168 26.2898 23.5936 26.1815 23.4501 26.1069C23.3066 26.0323 23.1472 25.9935 22.9855 25.9941H15.9871Z"
        stroke="#F68934"
        strokeWidth="1.99954"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BoostPlanIcon;
